import { useSelector } from "react-redux";
import { RootState } from "..";

export const useToastList = () => {
  return useSelector((state: RootState) => {
    return state.toaster.toasts;
  });
};
